/* Cazameeza Winter Version — PDP CRO layer. Unpublished theme only. */
(function () {
  'use strict';

  var AOV_TIERS = [
    { goal: 300000, discount: 10 },
    { goal: 500000, discount: 15 },
    { goal: 700000, discount: 20 }
  ];

  function visualAovProgress(cents) {
    var value = Math.max(0, Number(cents || 0));
    if (value >= 700000) return 100;
    if (value <= 300000) return (value / 300000) * 33.333333;
    if (value <= 500000) return 33.333333 + ((value - 300000) / 200000) * 33.333334;
    return 66.666667 + ((value - 500000) / 200000) * 33.333333;
  }

  function moneyEGP(cents) {
    var amount = Math.max(0, Math.ceil(Number(cents || 0) / 100));
    try {
      return new Intl.NumberFormat('en-EG').format(amount) + ' LE';
    } catch (e) {
      return String(amount) + ' LE';
    }
  }

  function getConfig() {
    var node = document.getElementById('caza-winter-pdp-config');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function annotateSoldOut(root) {
    (root || document).querySelectorAll('.t4s-swatch__item.is--soldout').forEach(function (item) {
      item.setAttribute('aria-disabled', 'true');
      var value = item.getAttribute('data-value') || item.textContent.trim();
      if (value && !item.getAttribute('aria-label')) item.setAttribute('aria-label', value + ' — Sold out');
    });
  }

  function readSelectedInventory(select) {
    if (!select || select.selectedIndex < 0) return null;
    var option = select.options[select.selectedIndex];
    if (!option) return null;

    var rawQty = option.getAttribute('data-inventoryquantity');
    var qty = Number(rawQty);
    if (!Number.isFinite(qty)) return null;

    var policy = String(option.getAttribute('data-inventorypolicy') || '').replace(/^['\"]|['\"]$/g, '').toLowerCase();
    return { qty: qty, policy: policy, disabled: option.disabled };
  }

  function stockMessage(qty) {
    if (qty === 1) return 'Last one in this size';
    if (qty >= 2 && qty <= 5) return 'Only ' + qty + ' left in this size';
    if (qty >= 6 && qty <= 10) return 'Low stock — ' + qty + ' left in this size';
    return '';
  }

  function initRealStock(form) {
    if (!form || form.dataset.cazaRealStockReady === '1') return;

    var helper = form.querySelector('[data-caza-size-helper]');
    var select = form.querySelector('select[name="id"]');
    if (!helper || !select) return;

    form.dataset.cazaRealStockReady = '1';

    var box = document.createElement('div');
    box.className = 'caza-real-stock';
    box.setAttribute('data-caza-real-stock', '');
    box.setAttribute('aria-live', 'polite');
    box.innerHTML = '<span class="caza-real-stock__dot" aria-hidden="true"></span><span data-caza-real-stock-text></span>';
    helper.insertAdjacentElement('afterend', box);

    var text = box.querySelector('[data-caza-real-stock-text]');

    function update() {
      var inventory = readSelectedInventory(select);
      box.classList.remove('is-visible', 'is-critical');
      text.textContent = '';

      if (!inventory || inventory.disabled) return;
      if (inventory.policy === 'continue') return;
      if (inventory.qty <= 0 || inventory.qty > 10) return;

      var message = stockMessage(inventory.qty);
      if (!message) return;

      text.textContent = message;
      box.classList.add('is-visible');
      if (inventory.qty <= 5) box.classList.add('is-critical');
    }

    select.addEventListener('change', function () { window.setTimeout(update, 0); });
    form._cazaStockUpdate = update;
    update();
  }

  function classifySeason(config) {
    if (!config || !config.taxonomyUrl || !config.handle) return;

    fetch(config.taxonomyUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('taxonomy unavailable');
        return res.json();
      })
      .then(function (taxonomy) {
        var groups = taxonomy && taxonomy.season_groups ? taxonomy.season_groups : {};
        var season = 'review';

        if (Array.isArray(groups['winter-26']) && groups['winter-26'].indexOf(config.handle) !== -1) {
          season = 'winter';
        } else if (Array.isArray(groups['summer-26']) && groups['summer-26'].indexOf(config.handle) !== -1) {
          season = 'summer';
        }

        document.documentElement.setAttribute('data-caza-season', season);
      })
      .catch(function () {
        document.documentElement.setAttribute('data-caza-season', 'review');
      });
  }

  function enhanceTrust(root) {
    var chips = (root || document).querySelectorAll('.t4s-section-main-product .cz-soft-trust__chip');
    if (!chips.length) return;

    var labels = [
      'Cash on delivery',
      'Size help available',
      'Inspect before you pay (Cairo & Giza)'
    ];

    chips.forEach(function (chip, index) {
      if (!labels[index] || chip.dataset.cazaTrustReady === '1') return;
      chip.innerHTML = '<span class="cz-soft-trust__icon">✓</span>' + labels[index];
      chip.dataset.cazaTrustReady = '1';
    });
  }

  function readVariantPrices(form, config) {
    var prices = {};
    var callback = form ? form.closest('[data-callBackVariant]') : null;
    var jsonNode = callback ? callback.querySelector('.pr_variants_json') : null;

    if (jsonNode) {
      try {
        JSON.parse(jsonNode.textContent || '[]').forEach(function (variant) {
          prices[String(variant.id)] = Number(variant.price || 0);
        });
      } catch (e) {}
    }

    if (config && config.initialVariantId && config.initialVariantPrice) {
      prices[String(config.initialVariantId)] = Number(config.initialVariantPrice);
    }

    return prices;
  }

  function selectedVariantId(form) {
    if (!form) return '';
    var select = form.querySelector('select[name="id"]');
    if (select && select.value) return String(select.value);
    var input = form.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function selectedQuantity(form) {
    if (!form) return 1;
    var input = form.querySelector('[data-quantity-value], input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function createAovBox() { return; }

  function initAov() { return; }

  function relocateFbt() {
    var main = document.querySelector('.t4s-section-main-product');
    var wrapper = document.querySelector('.t4s-liquid_custom_liquid_pUTAWc');
    if (!main || !wrapper || !wrapper.querySelector('.fbt-section')) return;

    if (!wrapper.classList.contains('caza-fbt-relocated')) {
      wrapper.classList.add('caza-fbt-relocated');
      main.appendChild(wrapper);
    }

    document.querySelectorAll('[id^="shopify-section-"][id*="product-recommendations"]').forEach(function (section) {
      section.classList.add('caza-hide-generic-recommendations');
    });
  }

  function fixRatingAnchor() {
    var rating = document.querySelector('.t4s-section-main-product .t4s-product__review');
    if (!rating || rating.dataset.cazaRatingReady === '1') return;

    rating.dataset.cazaRatingReady = '1';
    rating.addEventListener('click', function (event) {
      var target = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, #shopify-product-reviews, #looxReviews, .scm-reviews-importer');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function boot(root, config) {
    var scope = root || document;
    annotateSoldOut(scope);
    enhanceTrust(scope);
    scope.querySelectorAll('.t4s-section-main-product form.t4s-form__product').forEach(function (form) {
      initRealStock(form);
      initAov(form, config);
    });
    relocateFbt();
    fixRatingAnchor();
  }

  function start() {
    var config = getConfig();
    classifySeason(config);
    boot(document, config);

    var main = document.querySelector('.t4s-section-main-product');
    if (!main || !window.MutationObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        annotateSoldOut(main);
        enhanceTrust(main);
        main.querySelectorAll('form.t4s-form__product').forEach(function (form) {
          initRealStock(form);
          initAov(form, config);
        });
        relocateFbt();
        fixRatingAnchor();
      });
    });

    observer.observe(main, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    document.addEventListener('variant:changed', function () {
      window.setTimeout(function () {
        main.querySelectorAll('form.t4s-form__product').forEach(function (form) {
          initRealStock(form);
          initAov(form, config);
          if (typeof form._cazaStockUpdate === 'function') form._cazaStockUpdate();
          if (typeof form._cazaAovRender === 'function') form._cazaAovRender();
        });
      }, 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target, getConfig());
  });
})();
